import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  tabsContainer: {
    backgroundColor: theme.palette.background.paper,
    width: '100%'
  }
}));
